import React from 'react';

import { Text } from '@mantine/core';
import HelpButton, { HelpButtonProps } from 'components/HelpButton';

const AttendanceHelpButton = (props: Omit<HelpButtonProps, 'children'>): JSX.Element => {
  return (
    <HelpButton {...props}>
      <Text size='sm'>
        The attendance expectation is the number of times a package is expected to be attended per week,
        month, or year.
      </Text>
    </HelpButton>
  );
};

export default AttendanceHelpButton;
